import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import LoadingButton from "common/DS/LoadingButton";
import { localQuestions } from "redux/questions/selectors";
import { TextButton } from "common/DS/Buttons";

export default function QuestionButtonGroup(
    {
        handleBack,
        handleSkip,
        handleSubmit,
        nextDisabled,
        isLastQuestion,
        forceShowSkip,
        loading,
        additionalClassNames,
        buttonRenamer,
        isRequired,
    },
    { t: _ },
) {
    const groupClassName = classNames(
        additionalClassNames,
        "questions__follow-up-buttons",
        "ws-ds-button-container",
    );
    const questionCount = useSelector((state) => localQuestions(state).length);
    const isPreview = useSelector((state) => state.is_preview);

    // Only show skip if we have more than 1 question to show or we're renaming it
    const showSkip =
        !isRequired && !!handleSkip && (forceShowSkip || buttonRenamer.skip || questionCount > 1);
    const showSubmit = !!handleSubmit;
    const showBack = !!handleBack;

    // If we have no buttons, avoid taking up space in the container
    if (!showSkip && !showSubmit) {
        return null;
    }

    const skipTitle = buttonRenamer.skip || _("Skip");
    const backTitle = buttonRenamer.back || _("Back");
    const nextTitle = buttonRenamer.next || (isLastQuestion ? _("Send") : _("Next"));

    return (
        <div className={groupClassName}>
            {isPreview && (
                <div className="questions__answers-not-recorded">
                    <span>
                        Answers <strong>NOT</strong> Recorded
                    </span>
                </div>
            )}
            {showBack && (
                <TextButton className="questions__back-btn" size="large" onClick={handleBack}>
                    {backTitle}
                </TextButton>
            )}
            {showSkip && (
                <TextButton size="large" onClick={handleSkip} disabled={loading}>
                    {skipTitle}
                </TextButton>
            )}
            {showSubmit && (
                <LoadingButton onClick={handleSubmit} disabled={nextDisabled} loading={loading}>
                    {nextTitle}
                </LoadingButton>
            )}
        </div>
    );
}

QuestionButtonGroup.contextTypes = {
    t: PropTypes.func,
};

QuestionButtonGroup.propTypes = {
    handleBack: PropTypes.func,
    handleSkip: PropTypes.func,
    handleSubmit: PropTypes.func,
    nextDisabled: PropTypes.bool,
    isLastQuestion: PropTypes.bool,
    forceShowSkip: PropTypes.bool,
    loading: PropTypes.bool,
    isRequired: PropTypes.bool,
    additionalClassNames: PropTypes.string,
    buttonRenamer: PropTypes.object,
};

QuestionButtonGroup.defaultProps = {
    handleBack: null,
    handleSkip: null,
    handleSubmit: null,
    nextDisabled: false,
    isLastQuestion: false,
    forceShowSkip: false,
    loading: false,
    isRequired: false,
    additionalClassNames: "",
    buttonRenamer: {},
};
